export enum ZoomUpdateMode {
  // Immediately = 'Immediately', // Immediately is not supported currently
  FullSentence = 'FullSentence'
}
